/* eslint-disable @typescript-eslint/no-explicit-any, camelcase */

/**
 * This file is autogenerated, please don't edit it manually.
 * Use this command to regenerate it if you modified Epic experiments:
 * yarn epic:types
 */

/**
 * Epic experiments namespaces with their possible keys.
 * Autogenerated from static/bundles/epic/data/defaults/
 */
import client from 'bundles/epic/client';
import paymentsbackend from 'bundles/epic/data/defaults/payments-backend.json';
import type { Tags } from 'bundles/epic/lib/EpicTypes';

type Namespace = {
  sandboxEnabled: boolean;
  mockProcessorEnabled: boolean;
  useNewCurrency: any;
  '2024q1-charm-pricing-us': '2024q1-charm-pricing-us-control' | '2024q1-charm-pricing-us-variant-99c';
  stripeSubscriptionPaymentMethodConfig:
    | {
        stripeBvConsumer: 'pmc_1PC76EAEXNY2zYJrBbgPAPqB';
        stripeBvConsumerSandbox: 'pmc_1OyfCuAEXNY2zYJrm0Lbt9Fv';
        stripeConsumerSandbox: 'pmc_1PC3SwBEfO1jc2fnBE9wxPjn';
        stripeConsumer: 'pmc_1PqdhUBEfO1jc2fn2Y31iEKB';
      }
    | {
        stripeBvConsumer: 'pmc_1OWnaYAEXNY2zYJrmepxYhMZ';
        stripeBvConsumerSandbox: 'pmc_1OXUpdAEXNY2zYJrCca2KLbU';
        stripeConsumerSandbox: 'pmc_1MoD33BEfO1jc2fnlcWIQw3I';
        stripeConsumer: 'pmc_1MoD33BEfO1jc2fn4HVw9O1v';
      };
  enablePIX: boolean;
  enableLocalCurrencyPhp: boolean;
  enableStripeBillingEngineRazorpayABV2: boolean;
  indiaS12nSubscriptionEnabled: boolean;
  enableStripeBillingEngineDlocalAB: boolean;
};

const NAMESPACE = 'payments-backend';

// Adding safe optional chaining to avoid massive changes in unit tests.
client.addDefaults?.([paymentsbackend as $TSFixMe]);

const paymentsbackendEpicClient = {
  get<K extends keyof Namespace>(key: K, tags?: Tags): Namespace[K] {
    return client.get(NAMESPACE, key, tags);
  },

  preview<K extends keyof Namespace>(key: K, tags?: Tags, defaults?: Namespace): Namespace[K] {
    return client.preview(NAMESPACE, key, tags);
  },
};

export default paymentsbackendEpicClient;
